module.exports = __webpack_public_path__ + "static/media/banner.b37d0eee.png";